import { render, staticRenderFns } from "./ExtensionCards.vue?vue&type=template&id=b9e90e76&scoped=true"
import script from "./ExtensionCards.vue?vue&type=script&lang=js"
export * from "./ExtensionCards.vue?vue&type=script&lang=js"
import style0 from "./ExtensionCards.vue?vue&type=style&index=0&id=b9e90e76&prod&lang=scss&scoped=true"
import style1 from "./ExtensionCards.vue?vue&type=style&index=1&id=b9e90e76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9e90e76",
  null
  
)

export default component.exports